import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { OrganizationScope } from '../../platform';
import { AccountInvitationAdapter } from './invitationAdapter';
import { AccountInvitationRepository } from './invitationInterface';
import { AccountInvitationCreateProps } from './invitationProps';
import { AccountInvitationQuery } from './invitationQuery';

export function createAccountInvitationRepository(
    adapter: AccountInvitationAdapter
): AccountInvitationRepository {
    const PREFIX = ['account', 'invitation'];
    function getPrefix(context: OrganizationScope, query: AccountInvitationQuery) {
        return [...PREFIX, context.organization, query];
    }
    return {
        useFind(context, query, options) {
            const result = useQuery({
                ...options,
                queryKey: [...getPrefix(context, query)],
                async queryFn() {
                    const response = await adapter.find(context, query);
                    return response.items;
                },
            });
            return result;
        },
        useCreate(context) {
            const client = useQueryClient();
            const result = useMutation({
                async mutationFn(props: AccountInvitationCreateProps) {
                    const response = await adapter.create(context, props);
                    return response;
                },
                async onSuccess(data) {
                    await client.refetchQueries(PREFIX);
                },
            });
            return result;
        },
    };
}
